<div class="d-flex flex-column h-100">
    @if (articleId) {
        <adapt-styled-implementation-kit [articleId]="articleId"
                                         contentStyle="embedded"
                                         class="mb-4"></adapt-styled-implementation-kit>
    }

    @if ((!hidePurposeVision && (guidingPhilosophy?.vision || purpose?.content || guidingPhilosophy?.seeds || purpose?.seeds)) || bullseye) {
        <div class="mt-auto sticky-bottom px-2"
             [ngClass]="{ 'sticky-bottom': !!articleId }">
            <h4>Strategic guidance</h4>
            @if (area) {
                <p>Before setting your {{ area }}, click on the buttons below to see your strategic guidance.</p>
            }
            <div class="d-flex gap-1 flex-wrap border-bottom">
                @if (guidingPhilosophy?.seeds && !hidePurposeVision && showOwnersWhyAction) {
                    <button class="btn btn-info flex-fill"
                            (click)="showOwnersWhy()">Owners ‘why’</button>
                }
                @if (purpose?.content && !hidePurpose) {
                    <ng-container [ngTemplateOutlet]="showInformationalDialog"
                                  [ngTemplateOutletContext]="{
                            title: 'Purpose statement',
                            message: purpose!.content,
                        }"></ng-container>
                }
                <!-- Vision is crafted from align owners & vision - don't show if account disallows -->
                @if (purpose?.seeds && !hidePurposeVision && showOwnersAlignmentAction && hasOwnerAlignFeature) {
                    <button class="btn btn-info flex-fill"
                            (click)="showOwnersAlignment()">Vision</button>
                }
                @if (guidingPhilosophy?.vision && !hideVision) {
                    <ng-container [ngTemplateOutlet]="showInformationalDialog"
                                  [ngTemplateOutletContext]="{
                            title: 'Vision statement',
                            message: guidingPhilosophy!.vision,
                        }"></ng-container>
                }
                @if (bullseye && !hideBullseye) {
                    <button class="btn btn-info flex-fill"
                            (click)="showBullseye()">Bullseye</button>
                }
                <ng-template #showInformationalDialog
                             let-title="title"
                             let-message="message">
                    <button class="btn btn-info flex-fill"
                            (click)="showMessageDialog(title, message)">
                        {{ title }}
                    </button>
                </ng-template>
            </div>
        </div>
    }
</div>
